import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="side-navigation-drawer"
export default class extends Controller {
	static targets = ["dialog", "button"];

	connect() {
		document.addEventListener("turbo:before-cache", this.closeWithoutFocus);
		document.addEventListener("turbo:before-visit", this.closeWithoutFocus);
	}

	disconnect() {
		document.removeEventListener("turbo:before-cache", this.closeWithoutFocus);
		document.removeEventListener("turbo:before-visit", this.closeWithoutFocus);
		this.closeDrawer({ restoreFocus: false });
	}

	openDrawer(event) {
		event.preventDefault();
		event.stopPropagation();

		if (this.dialogTarget.open) {
			this.closeDrawer();
			return;
		}

		// Closes the phone search row (and any desktop panel), whose Escape handler would otherwise swallow the dialog's own.
		document.dispatchEvent(new CustomEvent("top-navigation-drawer:open", { detail: { drawer: this.element } }));

		if (typeof this.dialogTarget.showModal === "function") {
			this.dialogTarget.showModal();
		} else {
			this.dialogTarget.setAttribute("open", "");
		}

		this.buttonTarget.setAttribute("aria-expanded", "true");
	}

	closeDrawer({ restoreFocus = true } = {}) {
		if (!this.dialogTarget.open) {
			this.buttonTarget.setAttribute("aria-expanded", "false");
			return;
		}

		this.restoreFocus = restoreFocus;
		if (typeof this.dialogTarget.close === "function") {
			this.dialogTarget.close();
		} else {
			this.dialogTarget.removeAttribute("open");
			this.closed();
		}
	}

	backdropClose(event) {
		if (event.target === this.dialogTarget) {
			this.closeDrawer();
		}
	}

	closed() {
		this.buttonTarget.setAttribute("aria-expanded", "false");

		if (this.restoreFocus !== false) {
			this.buttonTarget.focus();
		}

		this.restoreFocus = true;
	}

	closeWithoutFocus = () => {
		this.closeDrawer({ restoreFocus: false });
	};
}
